import { defineModule } from '@core/modules';
import { ModulePath, ModuleTitle } from '@common/types';
import DocumentsAll from './containers';

export default defineModule({
  title: ModuleTitle.DocumentsAll,
  path: ModulePath.DocumentsAll,
  component: DocumentsAll
});
